<template lang="pug">

    .two.fields

        .field
            Label(v-if='showLabel') Art
            select.ui.dropdown(v-model='type')
                option
                option(value='COURIER') Kurier
                option(value='PROOF') Proof
                option(value='SAMPLE') Muster
                option(value='OTHER') Sonstiges
            field-error(v-bind:$v='$v.type' validator='required')
                | Darf nicht leer sein. Art bitte angeben.

        .field

            label(v-if='showLabel') Kosten
            .fields
                .fourteen.wide.field
                    input(type="number" min="0" v-model.number="amount")
                    field-error(v-bind:$v='$v.amount' validator='required')
                        | Darf nicht leer sein. Kosten bitte angeben.

                .two.wide.field
                    a.ui.basic.icon.button(v-on:click="remove")
                        i.trash.link.icon


</template>

<script>
    import * as R from 'ramda'
    import { requiredIf } from 'vuelidate/lib/validators'
    import FieldError from '@/components/form/FieldError'

    //noinspection ReservedWordAsName
    export default {

        components: { FieldError },

        computed: {

            amount: {
                get() { return this.model.amount },
                set(value) { this.model = R.assoc('amount', value, this.model) }
            },

            type: {
                get() { return this.model.type },
                set(value) { this.model = R.assoc('type', value, this.model) }
            },

            model: {
                get() { return this.value },
                set(value) { this.$emit('input', value) }
            }

        },

        methods: {

            persist() {
                // Model speichern
                const model = this.value

                // Pruefen ob Wert vorhanden
                if (R.isNil(this.value.id)) {
                    // Kosten erstellen
                    return this.$store.dispatch('additionalCosts/create', { model })

                } else {
                    // Kosten aktualisieren
                    return this.$store.dispatch('additionalCosts/update', { id: model.id, model })
                }
            },

            remove() {
                // Pruefen ob Datensatz ID besitzt und auch vom Server gelöscht werden muss
                if (!R.isNil(this.model.id)) {
                    this.$store.dispatch('additionalCosts/remove', { model: this.model })
                }

                // Parent über Entferung informieren
                this.$emit('remove')
            },

            async validate() {
                this.$v.$touch()
                return !this.$v.$invalid
            }

        },

        props: {

            showLabel: {
                type: Boolean,
                default: true
            },

            value: {
                type: Object,
                required: true
            },

        },

        validations: {

            amount: {
                required: requiredIf(vm => R.defaultTo('', vm.value.type) !== '')
            },

            type: {
                required: requiredIf(vm => R.defaultTo('', vm.value.amount) !== '')
            },

        }

    }

</script>
